module.exports = __webpack_public_path__ + "static/media/7.21.bd48a1a3.png";